module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container production"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('floating'), _vm._v(" "), _c('div', {
    staticClass: "production__recommend"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length === 0),
      expression: "list.length === 0"
    }],
    staticClass: "message",
    staticStyle: {
      "margin-top": "200px"
    }
  }, [_vm._v("\n          暂无数据\n        ")]), _vm._v(" "), _c('borrowList', {
    attrs: {
      "data-list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length !== 0),
      expression: "list.length !== 0"
    }],
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('pagebar', {
    attrs: {
      "count": _vm.count,
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage
    },
    on: {
      "on-page-click": _vm.onPageClick
    }
  })], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__title"
  }, [_c('h2', {
    staticClass: "large__title"
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('h4', {
    staticClass: "small__title square"
  }, [_vm._v("PRODUCT INTRODUCTION")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-68704648"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/borrow.vue
// module id = 611
// module chunks = 1